<div class="body" [formGroup]="formGroup">

    <div class="header-data-wrapper">

        <div class="title-wrapper">

            <mat-form-field class="width" [appearance]="appearance">

                <mat-label class="label">Bezeichnung</mat-label>
                <input formControlName="contractdesc" matInput placeholder="z.B. Vertrag Wista" [readonly]="!editMode" />
        
                <button mat-icon-button matSuffix [disabled]="!editMode || !contractdescControl.value" color="warn" (click)="clearDescription()">
                    <mat-icon>clear</mat-icon>
                </button>
        
            </mat-form-field>

        </div>
    
        <ng-container *ngIf="doubletService && (doubletService.checkerVisible$|async)">
    
            <app-doublet-checker></app-doublet-checker>
    
        </ng-container>

    </div>

    <div class="content">

        <div class="section header-data">

            <mat-form-field class="width" [appearance]="appearance">
                <mat-label class="label">Vertragsnummer</mat-label>
                <input formControlName="contractnumber" matInput placeholder="Vertragsnummer" [readonly]="!editMode" />
                <button *ngIf="editMode && showIdGenerator" mat-icon-button matSuffix matTooltip="Automatisch erzeugen" (click)="generateContractNumber()">
                    <mat-icon>adb</mat-icon>
                </button>
            </mat-form-field>

            <app-select-contract-type formControlName="contracttype"></app-select-contract-type>

            <app-select-contract-status formControlName="contractstate"></app-select-contract-status>

            <app-select-customer formControlName="contractcustomer" [appearance]="appearance"></app-select-customer>

        </div>

        <div class="section quill-wrapper quill-wrapper-white-toolbar quill-wrapper-graduated-bg">

            <quill-editor formControlName="contractnote" [modules]="modules"></quill-editor>

        </div>

    </div>

</div>